module.exports = __webpack_public_path__ + "img/photo-of-sofa-near-wooden-table-3264492.4d939fb1.jpg";